import { z } from 'zod';

import { zodTaxCodeSchema } from '../validations';

const hasAtMostTwoDecimalPlaces = (value: number) =>
  Math.abs(value * 100 - Math.round(value * 100)) < 1e-9;

const zodNumericTaxCodeRateSchema = z
  .number()
  .min(0)
  .max(100)
  .refine(hasAtMostTwoDecimalPlaces, {
    message: 'Rate must have at most two decimal places',
  });

const zodStringTaxCodeRateSchema = z
  .string()
  .trim()
  .regex(/^\d{1,3}(?:\.\d{1,2})?$/)
  .refine((value) => Number(value) <= 100, {
    message: 'Rate must be between 0 and 100',
  });

export const zodCreateTaxCodesPayloadSchema = z.object({
  applyToAllCompaniesInAccount: z.boolean().default(false),
  code: z.string().trim().max(64).nullable(),
  companyIds: z.array(z.uuid()).max(1000).nullable(),
  isReverseCharge: z.boolean().default(false),
  name: z.string().trim().min(1).max(255),
  rate: z.union([zodNumericTaxCodeRateSchema, zodStringTaxCodeRateSchema]),
});

export const zodCreateTaxCodesResponseSchema = z.object({
  data: z.array(zodTaxCodeSchema),
});
